import React, { useState, useEffect, useContext } from 'react'
import { MatchupContext } from '../../../../Context'
import { MatchupRosterCon } from './styles'
import { PlayerDataGQL } from '../../../../Api'
import { RosterTable } from './RosterTable'

type TeamRosterProps = {
  players: PlayerDataGQL[]
  theme?: 'light' | 'dark'
}

export const TeamRoster: React.FC<React.PropsWithChildren<TeamRosterProps>> = ({
  players,
  theme = 'light',
}) => {
  const { eventInfo } = useContext(MatchupContext)!
  const [activeRoster, setActiveRoster] = useState<PlayerDataGQL[]>([])
  const [inactiveRoster, setInactiveRoster] = useState<PlayerDataGQL[]>([])
  const [fullRoster, setFullRoster] = useState<PlayerDataGQL[]>([])

  useEffect(() => {
    filterRosters()
  }, [])

  const filterRosters = () => {
    const active = players
      .filter((pl) => pl.rosterStatus === 'active' || pl.rosterStatus === 'starter')
      .sort((a, b) => a.jerseyNum - b.jerseyNum)

    const inactive = players
      .filter(
        (pl) =>
          pl.rosterStatus === 'inactive' ||
          pl.rosterStatus === 'reserve' ||
          pl.rosterStatus === 'injured' ||
          !pl.rosterStatus
      )
      .sort((a, b) => a.jerseyNum - b.jerseyNum)

    if (active.length > 0) {
      setActiveRoster(active)
      setInactiveRoster(inactive)
    } else {
      const sortedFullRoster = players.sort((a, b) => a.jerseyNum - b.jerseyNum)
      setFullRoster(sortedFullRoster)
    }
  }

  return (
    <MatchupRosterCon uiTheme={theme}>
      {activeRoster.length > 0 && (
        <RosterTable
          eventId={eventInfo?.slugname || ''}
          rosterType={'Active'}
          roster={activeRoster}
          theme={theme}
        />
      )}
      {inactiveRoster.length > 0 && (
        <RosterTable
          eventId={eventInfo?.slugname || ''}
          rosterType={'Inactive'}
          roster={inactiveRoster}
          theme={theme}
        />
      )}
      {fullRoster.length > 0 && (
        <RosterTable
          eventId={eventInfo?.slugname || ''}
          rosterType={'Full'}
          roster={fullRoster}
          theme={theme}
        />
      )}
    </MatchupRosterCon>
  )
}
